// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./dragdroptouch"

// Import Rails UJS and ActionText if needed
import Rails from "@rails/ujs"
Rails.start()

// Import Trix editor for ActionText
import "trix"
import "@rails/actiontext"
